var _path, _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgFullRepresentation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.4957 16.1465L52.9994 57H61.4994C73.2524 48.3935 74.0712 16.1465 59.4957 16.1465Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.4945 16.1474C57.551 14.9674 47.294 11.9706 39.505 16.1474C29.9268 21.2836 23.4876 38.3061 36.9991 57C40.0184 57.0265 43.4989 57 43.4989 57L59.4945 16.1474Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3338 53.167H57.2734V50.5731H41.7261V53.1643C41.7261 55.7029 41.7155 58.4622 39.505 60.1313V84.9994H49.4997C49.4997 84.9994 54.7333 84.9994 59.4945 84.9994V60.0924C57.3405 58.4191 57.3338 55.6838 57.3338 53.167Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.5002 76.4123C46.1943 76.4123 42.021 73.7109 39.9992 72.2955L42.8371 105H58.3843V72.2955C55.865 74.8835 52.8062 76.4123 49.5002 76.4123Z",
    fill: "#3A8761"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3842 65.0111C58.7894 65.1216 59.1543 65.1805 59.4947 65.2092V60.0936C57.3409 58.4203 57.334 55.6848 57.334 53.168L57.3325 53.1035V50.5096L45.0579 50.5741L41.7263 51.6846C43.9474 54.1835 50.7495 62.9289 58.3842 65.0111Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0471 36.1358C65.0471 45.029 56.2025 56.1253 49.4998 56.1253C42.7972 56.1253 33.9525 45.029 33.9525 36.1358C33.9525 27.2426 40.9134 23.9199 49.4998 23.9199C58.0862 23.9199 65.0471 27.2426 65.0471 36.1358Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.7216 18.3672C51.0977 18.3672 49.0719 19.0683 47.4161 19.6826L47.2796 19.4777C47.2796 19.4777 47.0511 19.6572 46.6555 19.9684C45.7345 20.3181 45.0586 20.5882 45.0586 20.5882L45.3184 21.0212C41.1033 24.3422 31.4864 31.9391 30.6217 32.804C29.5112 33.9145 37.2848 62.2474 37.2848 46.1303C37.2848 32.6653 44.7657 29.9986 51.7216 28.362C54.8681 27.6216 55.7936 25.7707 56.1637 23.9199C56.534 22.0691 52.8323 18.3672 51.7216 18.3672Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0524 25.0306C57.0884 32.3415 61.1603 35.65 64.9778 36.6217C67.0696 37.1542 66.1578 30.5833 66.1578 30.5833C66.1578 30.5833 63.1963 22.9946 62.8262 22.8097C62.4561 22.6245 59.4946 16.1465 59.4946 16.1465L52.8315 21.6992L55.0524 25.0306Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.2637 58.8014C39.1439 60.4912 36.861 61.6792 32.1761 61.6792H31.7776C24.5145 61.6792 18.6264 67.1483 18.6264 73.8951V101.669C18.6264 103.509 20.2321 105 22.2131 105H56.7459L40.2637 58.8014Z",
    fill: "#EDF5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7364 58.8014C59.8562 60.4912 62.1391 61.6792 66.8241 61.6792H67.2225C74.4856 61.6792 80.3738 67.1483 80.3738 73.8951V101.669C80.3738 103.509 78.768 105 76.7871 105H42.2542L58.7364 58.8014Z",
    fill: "#EDF5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 21L36 12.3846C38 10.9487 41 7 50 7C59 7 62.3333 10.9487 64 12.3846L60 21C58.8333 20.2821 54.4 18.8462 50 18.8462C45.6 18.8462 41.5 20.2821 40 21Z",
    fill: "#EDF5F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0164 12.0164H50.9836V10.9836C50.9836 10.4401 50.5435 10 50 10C49.4565 10 49.0164 10.4401 49.0164 10.9836V12.0164H47.9836C47.4406 12.0164 47 12.4565 47 13C47 13.543 47.4406 13.9836 47.9836 13.9836H49.0164V15.0159C49.0164 15.5594 49.4565 16 50 16C50.5435 16 50.9836 15.5594 50.9836 15.0159V13.9831H52.0164C52.5594 13.9831 53 13.543 53 12.9995C53 12.4565 52.5594 12.0164 52.0164 12.0164Z",
    fill: "#89B59F"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgFullRepresentation);
export default __webpack_public_path__ + "static/media/imgFullRepresentation.63a202bdb5bab9fa8ccd1531d5a6085a.svg";
export { ForwardRef as ReactComponent };